var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"profile-assistant-button",attrs:{"type":"button"},on:{"click":_setup.open}},[_c(_setup.AiIcon,{staticClass:"c-icon"}),_c('span',{staticClass:"c-label"},[_vm._v(_vm._s(_setup.t('profilePdfUpload.button.label')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }